'use client';

import { c as _c } from "react/compiler-runtime";
import { Code2, Check } from 'lucide-react';
import { Mode, ModeConfig } from '@/components/shared/types';
interface SkillsSectionProps {
  activeMode: Mode;
  design: ModeConfig['design'];
  isDark: boolean;
  skills: string[];
}
export default function SkillsSection(t0) {
  const $ = _c(16);
  const {
    activeMode,
    design,
    isDark,
    skills
  } = t0;
  const t1 = `${activeMode === "ai" ? "p-6" : "p-5"} ${design.borderRadius === "rounded-xl" ? "rounded-xl" : design.borderRadius === "rounded-2xl" ? "rounded-2xl" : design.borderRadius === "rounded-3xl" ? "rounded-3xl" : "rounded-lg"} border transition-all duration-500 ${design.shadow} ${activeMode === "mobile" ? "glass-effect border-slate-400/20" : activeMode === "ai" ? `${design.cardBg} ${design.cardBorder}` : isDark ? `bg-white/5 ${design.border}` : activeMode === "frontend" ? `bg-white ${design.border}` : activeMode === "qa" ? "bg-white/40 backdrop-blur-xl border border-white/30 shadow-sm" : `bg-white ${design.border}`}`;
  const t2 = `flex items-center gap-2 mb-4 text-xs font-bold uppercase tracking-widest opacity-50 ${design.textSecondary}`;
  let t3;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t3 = <Code2 className="h-3 w-3" />;
    $[0] = t3;
  } else {
    t3 = $[0];
  }
  let t4;
  if ($[1] !== t2) {
    t4 = <div className={t2}>{t3} Relevant Skills</div>;
    $[1] = t2;
    $[2] = t4;
  } else {
    t4 = $[2];
  }
  let t5;
  if ($[3] !== activeMode || $[4] !== design.borderRadius || $[5] !== skills) {
    let t6;
    if ($[7] !== activeMode || $[8] !== design.borderRadius) {
      t6 = skill => <span key={skill} className={`text-xs px-2.5 py-1.5 ${design.borderRadius === "rounded-xl" ? "rounded-lg" : design.borderRadius === "rounded-3xl" ? "rounded-2xl" : design.borderRadius} font-medium transition-all duration-300 ${activeMode === "blockchain" ? "bg-[#003300] text-[#00FF41] green-glow" : activeMode === "backend" ? "bg-white/10 text-emerald-400" : activeMode === "mobile" ? "glass-effect border border-sky-400/30 text-sky-300" : activeMode === "frontend" ? "bg-rose-100 text-rose-700" : activeMode === "qa" ? "bg-white/60 backdrop-blur border border-cyan-200/60 text-cyan-700 shadow-sm" : activeMode === "ai" ? "bg-[#0B0C10] text-[#00F0FF] border border-[#00F0FF]/30" : "bg-indigo-100 text-indigo-700"}`}>{activeMode === "qa" && <Check className="inline h-3 w-3 mr-1 text-green-500" />}{skill}</span>;
      $[7] = activeMode;
      $[8] = design.borderRadius;
      $[9] = t6;
    } else {
      t6 = $[9];
    }
    t5 = skills.map(t6);
    $[3] = activeMode;
    $[4] = design.borderRadius;
    $[5] = skills;
    $[6] = t5;
  } else {
    t5 = $[6];
  }
  let t6;
  if ($[10] !== t5) {
    t6 = <div className="flex flex-wrap gap-2">{t5}</div>;
    $[10] = t5;
    $[11] = t6;
  } else {
    t6 = $[11];
  }
  let t7;
  if ($[12] !== t1 || $[13] !== t4 || $[14] !== t6) {
    t7 = <div className={t1}>{t4}{t6}</div>;
    $[12] = t1;
    $[13] = t4;
    $[14] = t6;
    $[15] = t7;
  } else {
    t7 = $[15];
  }
  return t7;
}